__turbopack_context__.v({
  "appear-slide-left": "FixedBackground-module-scss-module__nf4Diq__appear-slide-left",
  "bounceTwice": "FixedBackground-module-scss-module__nf4Diq__bounceTwice",
  "fade-in-bottom": "FixedBackground-module-scss-module__nf4Diq__fade-in-bottom",
  "fade-in-left": "FixedBackground-module-scss-module__nf4Diq__fade-in-left",
  "fade-in-right": "FixedBackground-module-scss-module__nf4Diq__fade-in-right",
  "fadeIn": "FixedBackground-module-scss-module__nf4Diq__fadeIn",
  "fixedContainer": "FixedBackground-module-scss-module__nf4Diq__fixedContainer",
  "loader": "FixedBackground-module-scss-module__nf4Diq__loader",
  "puff-in-center": "FixedBackground-module-scss-module__nf4Diq__puff-in-center",
  "puff-in-left": "FixedBackground-module-scss-module__nf4Diq__puff-in-left",
  "pulse": "FixedBackground-module-scss-module__nf4Diq__pulse",
  "pulse-contact": "FixedBackground-module-scss-module__nf4Diq__pulse-contact",
  "shake-bottom": "FixedBackground-module-scss-module__nf4Diq__shake-bottom",
  "slide-again": "FixedBackground-module-scss-module__nf4Diq__slide-again",
  "slide-in-right": "FixedBackground-module-scss-module__nf4Diq__slide-in-right",
  "stepContent-entrance": "FixedBackground-module-scss-module__nf4Diq__stepContent-entrance",
});
